import { HttpClient, HttpResponse } from "@angular/common/http";
import { computed, inject, Injectable, Signal } from "@angular/core";
import { PROJECT_NUMBER } from "@features/project/constants/routes.constant";
import { ProjectDefaultTimesDto } from "@core/services/project/project.dto";
import { BehaviorSubject, Observable, shareReplay, switchMap, tap } from "rxjs";

@Injectable()
export class ProjectOpeningTimesDataService {
  private readonly _projectNumber: string = inject(PROJECT_NUMBER);

  private readonly _httpClient: HttpClient = inject(HttpClient);

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  private readonly _basePath: Signal<string> = computed(() => `api/projects/${ this._projectNumber }`);

  private _update$: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);

  public readonly data$: Observable<ProjectDefaultTimesDto> = this._update$
    .pipe(
      switchMap(() => this.fetchOpeningTimes()),
      shareReplay({ bufferSize: 1, refCount: true })
    );

  private fetchOpeningTimes (): Observable<ProjectDefaultTimesDto> {
    return this._httpClient.get<ProjectDefaultTimesDto>(
      `${ this._basePath() }/default-opening-times`
    );
  }

  /**
   * Reload data
   */
  public reload (): void {
    this._update$.next();
  }

  /**
   * Update opening times
   */
  public update (payload: ProjectDefaultTimesDto, hasOpeningTimes: boolean): Observable<HttpResponse<void>> {
    return this._httpClient.put<undefined>(
      `${ this._basePath() }/default-opening-times`,
      payload,
      { observe: "response" }
    ).pipe(
      tap({
        finalize: () => {
          this._update$.next();
        }
      })
    );
  }
}
